import routes from '@modules/stripe/stripe-payout/stripe-payout-routes';
import store from '@modules/stripe/stripe-payout/stripe-payout-store';

export default {
  routes,
  store,
};
